import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setEnvironment } from '../redux/slices/environmentSlice';

/**
 * Component that detects the current environment and sets it in Redux
 * This component doesn't render anything visible and should be included
 * high in the component tree, e.g., in App.js
 */
const EnvironmentDetector = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Determine environment based on URL
    const url = window.location.hostname;
    let detectedEnvironment = 'Production'; // Default to production
    
    if (url.includes('uat')) {
      detectedEnvironment = 'UAT';
    } else if (url.includes('localhost') || url.includes('127.0.0.1')) {
      detectedEnvironment = 'Development';
    }
    
    // Dispatch the environment to Redux
    dispatch(setEnvironment(detectedEnvironment));
  }, [dispatch]);

  // This component doesn't render anything visible
  return null;
};

export default EnvironmentDetector;